import React, { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Navigate, useNavigate } from "react-router-dom";
import { GetErrorPageUrl } from "src/actions/GetErrorPageUrl";
import { CheckboxComponent } from "src/components/ContainerCheckbox";
import Input from "src/components/Input/Input";
import UserCard from "src/components/UserCard/UserCard";
import { CPF, updateRegister } from "src/hooks/be";
import { ErrorResponse } from "src/hooks/errorReponse";
import { useQueryParams } from "src/hooks/queryParams";
import { CpfInput } from "src/types/form-inputs";
import { formatCPF, getByToken, validateCPF } from "src/utils/HandleCpf";
import Config from "../../../config";
import { AuthContext } from "../../../contexts/AuthContext";
import { ThemeContext } from "../../../contexts/ThemeContext";
import { sendEvent } from "../../../hooks/analytics";
import { getSafeRedirectUrl } from "../../../utils/security";
import {
  Button,
  Container,
  ContainerTerms,
  TermsText,
  TitleText,
  Wrapper
} from "./style";

const serviceId = localStorage.getItem("serviceId") || "";
const cpfNumber = getByToken();

const buildSalesUrl = (code: string): string => {
  const redirectUrl =
    getSafeRedirectUrl(localStorage.getItem("callbackUrl")) ||
    Config.DEFAULT_REDIRECT_URL;

  const url = new URL("authorization", Config.SALES_HOST);
  url.searchParams.append("code", code);
  url.searchParams.append("serviceId", serviceId);
  url.searchParams.append("redirectUrl", redirectUrl);

  return url.toString();
};

export const TermsOfUse = () => {
  const { user, authenticate } = useContext(AuthContext);
  useEffect(() => {
    authenticate();
  }, []);

  const { setHeaderReturn, setHeaderUser } = useContext(ThemeContext);
  const [checked, setChecked] = useState<boolean>(false);
  const queryParams = useQueryParams();
  const navigate = useNavigate();

  const globoId = localStorage.getItem("globoId") || "";
  const providerName = localStorage.getItem("providerName") || "";

  const {
    register,
    formState: { errors },
    setValue,
    trigger,
    getValues,
    handleSubmit
  } = useForm<CpfInput>();

  useEffect(() => {
    sendEvent(
      "alf_page_view",
      {
        user_code_provider_hit: "cadun",
        page_name_custom: "termos_de_uso_v2",
        provider_name: providerName
      },
      { user_code: globoId, user_code_provider: "cadun" }
    );
  }, [globoId, providerName]);

  setHeaderReturn(false);
  setHeaderUser(false);

  const code = queryParams.get("code");
  if (!code) {
    return <Navigate to={GetErrorPageUrl()} />;
  }

  const getErrorMessage = () => {
    switch (errors.docNumber?.type) {
      case "validate":
        return "CPF inválido. Verifique o CPF informado e tente novamente.";

      case "required":
        return "O CPF precisa ser preenchido.";

      default:
        return;
    }
  };

  const checkErrors = () => {
    if (
      errors.docNumber?.type === "required" ||
      errors.docNumber?.type === "validate"
    ) {
      return errors.docNumber?.type;
    }
  };

  const redirectToSales = () => {
    const url = buildSalesUrl(code);
    window.location.href = url;
  };

  const onSubmit = async () => {
    sendEvent(
      "component_click",
      {
        component_name: "proximo",
        component_type: "button",
        component_item_link_redirect: Config.SALES_HOST,
        page_name_custom: "termos_de_uso_v2",
        provider_name: providerName
      },
      {
        user_code: globoId,
        user_code_provider: "cadun"
      }
    );

    if (cpfNumber) {
      redirectToSales();
    }

    checkErrors();
    const docNumber: CPF = {
      document: getValues("docNumber")
    };

    if (
      docNumber.document &&
      validateCPF(docNumber.document) &&
      !checkErrors()
    ) {
      try {
        await updateRegister(docNumber);
      } catch (error) {
        return navigate(GetErrorPageUrl(error as ErrorResponse));
      }
      redirectToSales();
    }
  };

  return (
    <ContainerTerms>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Container>
          {user && <UserCard user={user} />}
          <TitleText>Finalize o seu cadastro</TitleText>
          {!cpfNumber && (
            <Wrapper>
              <Input
                type="text"
                label="CPF"
                aria-required={true}
                inputMode="numeric"
                placeholder="Informe o seu CPF"
                {...register("docNumber", {
                  required: true,
                  validate: (cpf: string) => validateCPF(cpf),
                  onChange: e => {
                    if (errors.docNumber) {
                      trigger("docNumber");
                    }
                    setValue("docNumber", formatCPF(e.target.value));
                  }
                })}
                errorMessage={getErrorMessage()}
              />
            </Wrapper>
          )}
          <TermsText>
            Para prosseguir, precisamos que você esteja de acordo com nossos
            Termos de Uso.
          </TermsText>
        </Container>
        <CheckboxComponent
          checked={checked}
          serviceId={serviceId}
          globoId={globoId}
          setChecked={setChecked}
        />
        <Button type="submit" disabled={!checked}>
          Próximo
        </Button>
      </form>
    </ContainerTerms>
  );
};
